import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-shared-error-dialog',
  templateUrl: './shared-error-dialog.component.html',
  styleUrls: ['./shared-error-dialog.component.scss']
})
export class SharedErrorDialogComponent {
  message?: string;

	constructor(
		private dialog_ref: MatDialogRef<SharedErrorDialogComponent>,
		@Inject(MAT_DIALOG_DATA) data: any,
	) {
		this.message = data.message;
	}

	onCloseClick(): void {
		this.dialog_ref.close();
	}
}
